export default {
  title: 'O seu fornecedor trata deste passo',
  description: {
    payments: 'Contacte {{partner}} para configurar os pagamentos online.',
    go_live: 'Contacte {{partner}} para colocar o seu restaurante online.',
  },
  fallback_partner: 'o seu fornecedor',
};
